var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.5C53.5228 48.5 58 44.0228 58 38.5C58 32.9772 53.5228 28.5 48 28.5C42.4772 28.5 38 32.9772 38 38.5C38 44.0228 42.4772 48.5 48 48.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8201 68.5C30.8201 60.76 38.5201 54.5 48.0001 54.5C49.9201 54.5 51.7801 54.76 53.5201 55.24",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60.5C68 61.14 67.92 61.76 67.76 62.36C67.58 63.16 67.26 63.94 66.84 64.62C65.46 66.94 62.92 68.5 60 68.5C57.94 68.5 56.08 67.7199 54.68 66.4399C54.08 65.9199 53.56 65.3 53.16 64.62C52.42 63.42 52 62 52 60.5C52 58.34 52.86 56.36 54.26 54.92C55.72 53.42 57.76 52.5 60 52.5C62.36 52.5 64.5 53.52 65.94 55.16C67.22 56.58 68 58.46 68 60.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.98 60.46H57.02",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57.54V63.52",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddIcon);
export default __webpack_public_path__ + "static/media/userAddIcon.d0998e616a6af6f911c8500019e3b196.svg";
export { ForwardRef as ReactComponent };